import { useContext } from 'react';
import { ChatContext } from '../contexts/chatContext.js';
import { EditModeContext } from '../contexts/editModeContext.js';

/** Which of the two side drawers are open. */
export interface OpenDrawers {
  /** The chat drawer, on the left (`md:w-[600px]`). */
  chat: boolean;
  /** The customize-island (decorations) drawer, on the right (`md:w-[400px]`). */
  decorations: boolean;
}

/**
 * Which side drawers are open, for HUD elements that must stay clear of them:
 * the video tile row centres itself in the width they leave (#131), and the
 * toasts move to the left of the customize drawer.
 *
 * The customize drawer is open exactly while decoration edit mode is active:
 * `GameUI` opens it together with entering edit mode, and closes it whenever
 * edit mode ends. Reading edit mode here keeps `GameUI`'s drawer state where
 * it is, and reads the context directly rather than through `useEditMode`,
 * which would announce edit mode on the socket once per caller.
 *
 * Both contexts are optional, so a component rendered on its own (in a test,
 * say) sees both drawers closed.
 */
export function useOpenDrawers(): OpenDrawers {
  const chat = useContext(ChatContext);
  const editMode = useContext(EditModeContext);
  return {
    chat: chat?.isOpen ?? false,
    decorations: editMode?.isActive ?? false
  };
}
